module.exports = __webpack_public_path__ + "static/media/PlaceMine.b1bda59c.wav";